
const m = window.require("@ember/modifier");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
